import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class ThemeModule { }
export interface Theme {
  name: string;
  properties: any;
}

export const light: Theme = {
  name: "light",
  properties: {
    "--background-default": "#FFFFFF",
    "--background-item-box": "#FFFFFF",
    "--heading-item-box": "#000000",
    "--background-right-default": "#FFFFFF",
    "--background-chart-box": "#FFFFFF",
  }
};

export const dark: Theme = {
  name: "dark",
  properties: {
    "--background-default": "#2C2C2C",
    "--background-item-box": "#576271",
    "--heading-item-box": "#FFFFFF",
    "--background-right-default": "#707070",
    "--background-chart-box": "#FFFFFF",
  }
};
